/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_10Inputs */

const en_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****`)
};

const fr_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration de sous-titres 608/708 dans la vidéo (mov, mp4, mxf, et plus)****`)
};

const de_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608/708 Untertitel in Video einbetten (mov, mp4, mxf und mehr)****`)
};

const it_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora sottotitoli 608/708 nel video (mov, mp4, mxf e altro)****`)
};

const ru_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание субтитров 608/708 в видео (mov, mp4, mxf и другие)****`)
};

const es_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incruste subtítulos 608/708 en video (mov, mp4, mxf y más)****`)
};

const zh_cn2_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在视频中嵌入 608/708 隐藏式字幕（mov、mp4、mxf 等格式）****`)
};

const ja_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608/708 クローズドキャプションをビデオに埋め込む (mov、mp4、mxf など)****`)
};

const hi_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में 608/708 क्लोज्ड कैप्शनिंग एम्बेड करें (mov, mp4, mxf, और अन्य)****`)
};

const pt_pt2_signup_feature_pro_10 = /** @type {(inputs: Signup_Feature_Pro_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpore legendas ocultas 608/708 em vídeos (mov, mp4, mxf e outros)****`)
};

/**
* | output |
* | --- |
* | "Embed 608/708 Closed Captioning in video (mov, mp4, mxf, and more)****" |
*
* @param {Signup_Feature_Pro_10Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_10 = /** @type {((inputs?: Signup_Feature_Pro_10Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_10Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_10(inputs)
	if (locale === "de") return de_signup_feature_pro_10(inputs)
	if (locale === "it") return it_signup_feature_pro_10(inputs)
	if (locale === "ru") return ru_signup_feature_pro_10(inputs)
	if (locale === "es") return es_signup_feature_pro_10(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_10(inputs)
	if (locale === "ja") return ja_signup_feature_pro_10(inputs)
	if (locale === "hi") return hi_signup_feature_pro_10(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_10(inputs)
	return en_signup_feature_pro_10(inputs)
});